import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    consultingCenterTabKey: '',
    currentCountry: {},
    aboutUsTabBar: {},
    sourceParam: null
  },
  getters: {
    getTabKey: state => state.consultingCenterTabKey,
    getCurrentCountry: state => state.currentCountry,
    getAboutUsTabBar: state => state.aboutUsTabBar
  },
  mutations: {
    setCconsultingTabKey(state, key) {
      state.consultingCenterTabKey = key
    },

    // 设置国家
    setCurrentCountry(state, country) {
      state.currentCountry = country
    },

    // 关于我们，设置tab栏
    setAboutUsTabBar(state, data) {
      state.aboutUsTabBar = data
    },

    SET_SOURCE_PARAM(state, value) {
      state.sourceParam = value
    },
    CLEAR_SOURCE_PARAM(state) {
      state.sourceParam = null
    }
  },
  actions: {
    setSourceParam({ commit }, value) {
      commit('SET_SOURCE_PARAM', value)
    }
  },
  modules: {}
})
